var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Addresses",
    "data-name": "Icon / Addresses",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "where_to_vote-black-18dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M8,22H8l-.739-.8C7.188,21.12,0,13.35,0,7.826A7.923,7.923,0,0,1,8,0a7.923,7.923,0,0,1,8,7.826c0,2.238-1.216,5.214-3.518,8.609A44.628,44.628,0,0,1,8.74,21.2L8,22ZM8,1.957A5.942,5.942,0,0,0,2,7.826c0,1.527.734,3.529,2.183,5.951A41.289,41.289,0,0,0,8,19.046a43.016,43.016,0,0,0,3.656-4.979C13.212,11.543,14,9.444,14,7.826A5.942,5.942,0,0,0,8,1.957ZM6.47,12.717h0L3.29,9.606,4.71,8.217,6.47,9.949l4.6-4.5,1.41,1.389-6.01,5.879Z",
    transform: "translate(4 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddress);
export default __webpack_public_path__ + "static/media/icon-address.d9931645ff7433a62d77e4267067a5d6.svg";
export { ForwardRef as ReactComponent };